/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sociaal_Emotioneel_Thema_Api_Errors_Maximum_Five_Sociaalemotioneeldoelen_Allowed2Inputs */

const nl_sociaal_emotioneel_thema_api_errors_maximum_five_sociaalemotioneeldoelen_allowed2 = /** @type {(inputs: Sociaal_Emotioneel_Thema_Api_Errors_Maximum_Five_Sociaalemotioneeldoelen_Allowed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er mag maximaal vijf sociaal-emotioneel doelen worden geselecteerd`)
};

/**

* @param {Sociaal_Emotioneel_Thema_Api_Errors_Maximum_Five_Sociaalemotioneeldoelen_Allowed2Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const sociaal_emotioneel_thema_api_errors_maximum_five_sociaalemotioneeldoelen_allowed2 = /** @type {((inputs?: Sociaal_Emotioneel_Thema_Api_Errors_Maximum_Five_Sociaalemotioneeldoelen_Allowed2Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sociaal_Emotioneel_Thema_Api_Errors_Maximum_Five_Sociaalemotioneeldoelen_Allowed2Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_sociaal_emotioneel_thema_api_errors_maximum_five_sociaalemotioneeldoelen_allowed2(inputs)
});
export { sociaal_emotioneel_thema_api_errors_maximum_five_sociaalemotioneeldoelen_allowed2 as "sociaal_emotioneel_thema.api_errors.maximum_five_sociaalEmotioneelDoelen_allowed" }